import { FC, ReactNode } from 'react';

import {
  Icon,
  Typography,
  TypographyProps,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { useTruncated } from 'src/hooks/useTruncated';

import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper';

import classes from './Truncate.module.scss';

export type TruncateProps = TypographyProps & {
  children?: ReactNode;
};

export const Truncate: FC<TruncateProps> = ({ children, ...rest }) => {
  const { truncated, setElement } = useTruncated();

  const title = children?.toString() ?? '';

  return (
    <div className={classes.container}>
      <Typography ellipsis {...rest} ref={setElement} className={classes.text}>
        {children}
      </Typography>
      {truncated && (
        <TooltipWrapper title={title}>
          <Icon iconName={Icons.InfoCircled} />
        </TooltipWrapper>
      )}
    </div>
  );
};
